<template>
  <div class="setting_main_contents">
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ labelMasterProperties.HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ labelMasterProperties.HEADER_EXPLAIN }}
      </p>
      <button class="setting_btn_outline btn-secondary-color mb-3" @click="resetMasterData()">
        {{ labelMasterProperties.BUTTON_RESET_MASTER_DATA }}
      </button>
    </div>
    <div :class="{'overlay_setting':isLoadingData || isResetData}">
      <i :class="{'loadding_setting': isLoadingData || isResetData}"></i>
    </div>
    <div class="setting_tab_content">
      <div class="setting_tab_content_panel is_active">
        <div class="setting_content">
          <div class="setting_content_main">
            <!-- <div class="setting_content_heading">
              <div class="setting_content_heading_holder">
                <h2 class="setting_content_title">
                  選択肢グループの設定
                </h2>
                <div class="setting_form_select_wrapper">
                  <select class="setting_form_select">
                    <option>&#45;&#45;</option>
                    <option>プルダウン</option>
                    <option>チェックボックス</option>
                    <option>ラジオボタン</option>
                  </select>
                </div>
              </div>
            </div> -->
            <div class="setting_category_header">
              <div class="setting_category_header_content">
                {{ labelMasterProperties.CATEGORY_HEADER }}
              </div>
              <div class="setting_category_header_operation_small">
                {{ labelMasterProperties.HEADER_OPERATION }}
              </div>
            </div>
            <div class="setting_category_wrapper">
              <div v-for="(masterSetting, index) in masterSettings" :key="index">
                <div class="setting_column_item"
                     :class="{'master_item_deleted': masterSetting && masterSetting.deletedDate}"
                     :title="masterSetting && masterSetting.deletedDate ? messageMasterProperties.MASTER_DELETED : ''">
                  <div class="setting_column_item_content setting_master_item_holder_name">
                    {{ masterSetting.name }}
                  </div>
                  <div class="setting_column_item_operation_add">
                    <div class="setting_column_item_operation">
                      <button class="setting_btn_secondary setting_btn_medium"
                              :class="{'setting_btn_disabled': masterSetting && masterSetting.deletedDate}"
                              @click.prevent="openEditMaster(index)">
                        {{ labelMasterProperties.BUTTON_EDIT_MASTER }}
                      </button>
                    </div>
                  </div>
                  <button v-if="masterSetting && masterSetting.deletedDate" class="setting_btn_delete setting_btn_medium"
                          @click.prevent="openDeleteModal(index)">
                    {{ labelMasterProperties.BUTTON_DELETE_MASTER }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="setting_footer">
      <button class="setting_btn_outline" @click.prevent="cancelChange">
        {{ labelProperties.CANCEL_BUTTON }}
      </button>
      <button class="setting_btn_primary" :class="{'setting_btn_disabled': !canSaveMaster}"
              @click.prevent="saveMasters">
        {{ labelProperties.SAVE_BUTTON }}
      </button>
      <div class="setting_footer_balloon" v-if="unSavedData">
        {{ labelMasterProperties.SAVE_CHANGE_DATA }}
      </div>
    </div>
    <div class="setting_modal" v-if="isOpenEditModal">
      <div class="setting_master_modal">
        <div class="setting_master_modal_header">
          <p class="setting_master_modal_header_title setting_master_item_holder_name">
            {{ selectedMaster.name + labelMasterProperties.MODAL_HEADER_TITLE }}
          </p>
          <div class="setting_master_modal_header_close">
            <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" @click.prevent="closeEditMasterModal">
              <g fill="#AAA" fill-rule="evenodd">
                <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"/>
                <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"/>
              </g>
            </svg>
          </div>
        </div>
        <div class="setting_master_modal_body">
          <div class="setting_master_item_header">
            <div class="setting_master_item_header_sorting">
              {{ labelMasterProperties.ITEM_HEADER_SORTING }}
            </div>
            <div class="setting_master_item_header_name">
              {{ labelMasterProperties.ITEM_HEADER_NAME }}
            </div>
            <div class="setting_master_item_header_form">
              {{ labelMasterProperties.ITEM_HEADER_FORM }}
            </div>
            <div class="setting_master_item_header_display">
              {{ labelMasterProperties.ITEM_HEADER_DISPLAY }}
            </div>
          </div>
          <div class="setting_master_item_wrapper">
            <draggable :list="selectedMaster.items" handle=".handle">
              <template v-for="(item, index) in selectedMaster.items">
                <div class="setting_master_item_holder" v-bind:key="index"
                     :class="{'master_item_deleted': item && item.deletedDate}"
                     :title="item && item.deletedDate ? messageMasterProperties.ITEM_DELETED : ''">
                  <div class="setting_master_item_holder_sorting handle">
                    <svg class="setting_master_item_holder_sorting_icon" width="10" height="12"
                         xmlns="http://www.w3.org/2000/svg">
                      <g fill="#aaa" fill-rule="evenodd">
                        <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                      </g>
                    </svg>
                  </div>
                  <div class="setting_master_item_holder_name">
                    {{ item.choiceName }}
                  </div>
                  <div class="setting_master_item_holder_form">
                    <input
                        class="setting_form_text"
                        type="text"
                        placeholder=""
                        v-model="item.choiceDisplayName"
                        @change="validateChoiceDisplayName(index)"
                    />
                    <p class="error_msg" v-show="choiceDisplayErrors.includes(index)">
                      {{ configMasterProperties.CHOICE_DISPLAY_NAME_MAX_LENGTH + messageMasterProperties.CHOICE_DISPLAY_NAME_MAX_LENGTH }}
                    </p>
                  </div>
                  <div class="setting_master_item_holder_display">
                    <label class="setting_form_checkbox_label">
                      <input type="checkbox" v-model="item.show" checked/>
                      <span class="setting_form_checkbox_text">
                        {{ labelMasterProperties.FORM_CHECKBOX_TEXT }}
                      </span>
                    </label>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
        <div class="setting_master_modal_footer">
          <button class="setting_btn_outline" @click.prevent="closeEditMasterModal">
            {{ labelMasterProperties.BUTTON_CLOSE }}
          </button>
          <button class="setting_btn_primary" :class="{'setting_btn_disabled': !canReflectMaster}"
                  @click.prevent="submitMasterItems">
            {{ labelMasterProperties.BUTTON_OK }}
          </button>
        </div>
      </div>
    </div>
    <div class="setting_modal" v-if="isOpenDeleteModal">
      <div class="setting_modal_box">
        <div class="setting_modal_box_body">
          <div class="setting_modal_box_close" @click="closePopupDeleteMaster">
            <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
              <g fill="#AAA" fill-rule="evenodd">
                <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
                <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
              </g>
            </svg>
          </div>
          <p class="setting_modal_box_text">
            {{ messageMasterProperties.CONFIRM_DELETE_MASTER_MESSAGE }}
          </p>
        </div>
        <div class="setting_modal_box_actions">
          <button class="setting_btn_outline" @click="closePopupDeleteMaster">
            {{ labelMasterProperties.BUTTON_CLOSE }}
          </button>
          <button
            class="setting_btn_primary"
            @click="deleteMaster()"
          >
            {{ labelMasterProperties.BUTTON_OK }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labelProperties from "../../properties/common_screen/commonsetting-labels.json";
import labelMasterProperties from "../../properties/master_screen/master-labels.json";
import messageMasterProperties from "../../properties/master_screen/master-messages.json";
import configMasterProperties from "../../properties/master_screen/master-config.json";
import masterSettingsService from "../../services/MasterSettingsService";
import VueToast from "vue-toast-notification";
import draggable from "vuedraggable";
import Vue from "vue";
import generalService from "../../services/GeneralService";
import * as generalLabels from "../../properties/general_page/generalpage-labels.json";
import * as generalMessages from "../../properties/general_page/generalpage.json";
import Utils from "../../Utils";
Vue.use(VueToast);

export default {
  name: "MasterSettings",
  props: ["groupName", "unSavedData", "userId", "token"],
  components: {
    draggable,
  },
  data() {
    return {
      labelProperties: labelProperties,
      labelMasterProperties: labelMasterProperties,
      messageMasterProperties: messageMasterProperties,
      configMasterProperties: configMasterProperties,
      masterSettings: [],
      selectedMaster: {
        items: [],
        name: "",
      },
      isOpenEditModal: false,
      selectedMasterIndex: -1,
      masterUpdates: [],
      log: {
        info: {},
      },
      isLoadingData: true,
      isResetData: false,
      choiceDisplayErrors: [],
      canReflectMaster: true,
      canSaveMaster: true,
      isOpenDeleteModal: false,
      indexMasterDelete : 0
    };
  },
  async created() {
    document.title = generalLabels.START_TITLE_PAGE + " > " + labelMasterProperties.MASTER_PAGE_TITLE;
    await this.createLogger("Load data " + generalLabels.FOURTH_TAB);
    await this.getMasterSettings(false, this.log.hash);
    this.isLoadingData = false;
  },
  methods: {
    async deleteMaster(){
      this.isLoadingData = true;
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + " Poup confirm delete master - Click button " + labelMasterProperties.BUTTON_OK);
      if(this.indexMasterDelete < 0){
        this.isLoadingData = false;
        this.isOpenDeleteModal = false;
        return;
      }
      let idMaster = this.masterSettings[this.indexMasterDelete].id;
      await masterSettingsService.deleteMaster(idMaster, this.log.hash, this.token).then(response => {
        if(response && response.data){
          this.isLoadingData = false;
          this.isOpenDeleteModal = false;
        }
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        this.isLoadingData = false;
        this.isOpenDeleteModal = false;
      })
      await this.getMasterSettings(false, this.log.hash);
    },

    async closePopupDeleteMaster(){
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + " Poup confirm delete master - Click button " + labelMasterProperties.BUTTON_CLOSE);
      this.isOpenDeleteModal = false;
    },

    async openDeleteModal(index) {
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "- Click button " + labelMasterProperties.BUTTON_DELETE_MASTER);
      this.isOpenDeleteModal = true;
      this.indexMasterDelete = index;
    },

    async getMasterSettings(duplicate, hash) {
      if (this.groupName === "") {
        return;
      }

      Vue.$toast.clear();
      await masterSettingsService.getAll(duplicate, hash).then(response => {
        if (response && response.data != null) {
          this.masterSettings = Object.keys(response.data).map((key) => {
            return response.data[key];
          });
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.error(messageMasterProperties.AN_ERROR_HAS_OCCURRED, {
          position: "bottom-right",
          duration: 3000,
        });
      });
    },

    async openEditMaster(index) {
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Click button " + labelMasterProperties.BUTTON_EDIT_MASTER + " " + this.masterSettings[index].name);
      this.isOpenEditModal = true;
      this.selectedMaster = JSON.parse(JSON.stringify(this.masterSettings[index]));
      this.selectedMasterIndex = index;
      this.canSaveMaster = false;
    },

    validateChoiceDisplayName(index) {
      if (this.selectedMaster.items[index].choiceDisplayName.length > configMasterProperties.CHOICE_DISPLAY_NAME_MAX_LENGTH) {
        if (!this.choiceDisplayErrors.includes(index)) {
          this.choiceDisplayErrors.push(index);
        }
      } else {
        let i = this.choiceDisplayErrors.indexOf(index);
        if (i !== -1) {
          this.choiceDisplayErrors.splice(i, 1);
        }
      }

      this.checkCanReflectMaster();
    },

    checkCanReflectMaster() {
      this.canReflectMaster = this.choiceDisplayErrors.length === 0;
    },

    async closeEditMasterModal() {
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Popup edit" + this.selectedMaster.name + " " + labelMasterProperties.MODAL_HEADER_TITLE + "-Click button " + labelMasterProperties.BUTTON_CLOSE);
      this.refreshSelectedMaster();
      this.isOpenEditModal = false;
      this.canReflectMaster = true;
      this.choiceDisplayErrors = [];
      this.canSaveMaster = true;
    },

    async submitMasterItems() {
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Popup edit" + this.selectedMaster.name + " " + labelMasterProperties.MODAL_HEADER_TITLE + "-Click button " + labelMasterProperties.BUTTON_OK);
      this.$eventBus.$emit("unSaved", true);
      this.masterSettings[this.selectedMasterIndex] = this.selectedMaster;
      this.masterUpdates.push(this.selectedMaster);
      await this.closeEditMasterModal();
    },

    refreshSelectedMaster() {
      this.selectedMaster = {
        items: [],
        name: "",
      };

      this.selectedMasterIndex = -1;
    },

    async cancelChange() {
      this.isLoadingData = true;
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Click button " + labelProperties.CANCEL_BUTTON);
      await this.getMasterSettings(false, this.log.hash);
      this.$eventBus.$emit("unSaved", false);
      this.isLoadingData = false;
    },

    async saveMasters() {
      this.isLoadingData = true;
      this.log.info.paras = this.masterUpdates;
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Click button " + labelProperties.SAVE_BUTTON);
      Vue.$toast.clear();
      await masterSettingsService.saveMasters(this.masterUpdates, this.log.hash, this.token).then(response => {
        Vue.$toast.success(messageMasterProperties.SAVE_MASTER_ITEM_SUCCESSFUL, {
              position: "bottom-right",
              duration: 3000,
            }
        );

        this.$eventBus.$emit("unSaved", false);
        this.masterUpdates = [];
        Object.keys(response.data).forEach(key => {
          this.masterSettings.map((master) => {
            if (master.key === key) {
              return response.data[key];
            }

            return master;
          });
        });
      }).catch(e => {
        console.log(e);
        Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
          position: "bottom-right",
          duration: 3000,
        });
      }).finally(() => {
        this.isLoadingData = false;
      });
      delete this.log.info.paras;
    },

    async resetMasterData() {
      this.isResetData = true;
      this.masterSettings = [];
      await this.createLogger("Menu " + generalLabels.FOURTH_TAB + "-Click button " + labelMasterProperties.BUTTON_RESET_MASTER_DATA);
      Vue.$toast.clear();
      await masterSettingsService.resetMasters(this.log.hash, this.token).then(response => {
        this.masterSettings = [];
        if (response && response.data != null) {
          this.masterSettings = Object.keys(response.data).map(key => {
            return response.data[key];
          });
        }

        Vue.$toast.success(
          messageMasterProperties.RESET_MASTER_ITEM_SUCCESSFUL, {
            position: "bottom-right",
            duration: 3000,
          }
        );
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
          position: "bottom-right",
          duration: 3000,
        });
      }).finally(() => {
        this.isResetData = false;
      });
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService.sendLogger(this.logs.hash, this.logs.info.path, this.logs).then(response => {
        if (response.status === 200) {
          return true;
        }
      }).catch(e => {
        console.log(e);
      });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.sendLogger(this.log);
    },
  },
};
</script>

<style scoped>
.btn-secondary-color {
  background-color: #6cb26e;
  color: #fff;
}

.setting_master_item_holder_name {
  word-break: break-all;
}

p {
  margin-bottom: 0 !important;
}

.master_item_deleted {
  background-color: #f16a6a !important;
}

.error_msg {
  color: #f16a6a;
  font-size: 14px;
  font-weight: 500;
}
.setting_heading{
  height: 28.8px;
}

.setting_master_modal_header {
  height: fit-content;
  position: relative;
}

.setting_master_modal_body {
  margin: 0;
}
</style>
